import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sbw-info-popup-demo',
    templateUrl: './info-popup-demo.component.html',
    styleUrls: ['./info-popup-demo.component.css']
})
export class InfoPopupDemoComponent implements OnInit {
    test = false
    constructor() { }

    ngOnInit() {
    }

}
